import React, { useState, useEffect, useRef } from "react";
import SlideOutMenuV2 from "@components/SlideOutMenuV2";
import { Form } from "react-bootstrap";
import { handleAlert } from "@utils/helperFunctions";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";
import useStyles from "../styles/useStyles";

interface Props {
  projectId: string;
  isOpen: boolean;
  onClose: () => void;
}

const ImportLocationsSlideout: React.FC<Props> = ({
  projectId,
  isOpen,
  onClose,
}) => {
  const styles = useStyles();
  const formRef = useRef<HTMLFormElement>(null);
  const [authenticityToken, setAuthenticityToken] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showFailAlert, setShowFailAlert] = useState(false);

  useEffect(() => {
    const meta = document.head.querySelector(
      "[name~=csrf-token][content]"
    ) as HTMLMetaElement | null;
    if (meta) {
      setAuthenticityToken(meta.content);
    }
  }, []);

  useEffect(() => {
    if (!isOpen) {
      setFile(null);
      setShowFailAlert(false);
    }
  }, [isOpen]);

  const handleSave = () => {
    if (!file) {
      setErrorMessage("Please select a file to import.");
      setShowFailAlert(true);
      return;
    }
    formRef.current?.submit();
  };

  return (
    <SlideOutMenuV2
      title="Import Service Locations"
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      actionBtnText="Import"
    >
      {handleAlert(
        showFailAlert,
        errorMessage,
        setShowFailAlert,
        "warning",
        ToastAlert
      )}
      <div style={{ padding: "16px" }}>
        <Form
          ref={formRef}
          encType="multipart/form-data"
          action={`/projects/${projectId}/project_imports`}
          acceptCharset="UTF-8"
          method="post"
        >
          <Form.Control name="utf8" type="hidden" value="&#x2713;" />
          <Form.Control
            type="hidden"
            name="authenticity_token"
            value={authenticityToken}
          />
          <Form.Control
            type="hidden"
            name="data_import[import_type]"
            value="service_locations"
          />
          <Form.Control
            type="hidden"
            name="data_import[context_type]"
            value="Project"
          />
          <Form.Control
            type="hidden"
            name="data_import[context_id]"
            value={projectId}
          />
          <Form.Group className="mb-3">
            <Form.Label className={styles.formLabel}>
              Service Locations (CSV or Excel)
            </Form.Label>
            <Form.Control
              type="file"
              name="data_import[data_file]"
              accept="csv,.xls,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFile(e.target.files?.[0] || null);
              }}
            />
          </Form.Group>
        </Form>
      </div>
    </SlideOutMenuV2>
  );
};

export default ImportLocationsSlideout;
